
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import DetailCharge from './components/DetailCharge.vue';
import DateTypeForm from './components/DateTypeForm.vue';
import DefaultTable from './components/Default.vue';
import RentTable from './components/Rent.vue';
import ExhibitionTable from './components/Exhibition.vue';
import UpdateScheduleForm from './components/UpdateScheduleForm.vue';
import DayScheduleForm from './components/DayScheduleForm.vue';
import { defaultReservationItem } from '@/api/reservationItem';
import { ReservationItemModule } from '@/store/modules/reservationItem';
import moment from 'moment';

@Component({
  components: {
    DetailCharge,
    DateTypeForm,
    DefaultTable,
    RentTable,
    ExhibitionTable,
    UpdateScheduleForm,
  },
})
export default class extends Vue {
  get formData() {
    return ReservationItemModule.form;
  }

  get updateScheduleDate() {
    return ReservationItemModule.updateScheduleDate;
  }

  set updateScheduleDate(val) {
    ReservationItemModule.setUpdateScheduleDate(val);
  }

  get isNew() {
    return ReservationItemModule.isNew;
  }

  // 일정 타입 데이터
  get scheduleType() {
    return ReservationItemModule.scheduleType;
  }

  set scheduleType(val: number | null) {
    if (val !== null) this.schedulePart = this.formData.schedulePart[val];
    ReservationItemModule.setUpdateScheduleDate('0');
    ReservationItemModule.setScheduleType(val);
  }

  private dateType = 'day';

  private limitDate = moment(ReservationItemModule.form.possiableUpdateDate);

  private schedulePart = {};

  private detailChargeVisible = false;

  private itemHours: any[] = [];

  private selectedDayType = '';

  private holidayForm: any = null;

  private holidayFormVisible = false;

  private updateScheduleVisible = false; // 일정&요금 업데이트 예정일 추가 모달 상태값

  private dayTypes = [
    { label: '평일', value: 'WEEKDAY' },
    { label: '토요일', value: 'SATURDAY' },
    { label: '일요일', value: 'SUNDAY' },
    { label: '공휴일', value: 'HOLIDAY' },
  ];

  private dateTypeFormVisible = false;

  private showDateTypeForm() {
    this.dateTypeFormVisible = true;
  }

  private closeDateType() {
    this.dateTypeFormVisible = false;
  }

  private getDateType(data: any) {
    this.closeDateType();
  }

  private openRangesValidator(rule: any, value: any, callback: any) {
    let notValidCount = 0;
    value.forEach((openRange: any) => {
      if (openRange.reserve.length !== 2 || openRange.use.length !== 2) notValidCount += 1;
    });
    if (notValidCount > 0) callback(new Error('설정할 기간을 입력하세요.'));
    callback();
  }

  private rules = {
    openRanges: [
      { validator: this.openRangesValidator, trigger: 'blur' },
    ],
  };

  private showTimeSchedule(data: any) {
    this.detailChargeVisible = true;
    this.selectedDayType = data.value;
  }

  private closeDetailCharge() {
    this.detailChargeVisible = false;
    this.itemHours = [];
    this.selectedDayType = '';
  }

  /**
   * 일정/요금 업데이트 예정일
   */
  private handleUpdateSchedule() {
    this.updateScheduleVisible = !this.updateScheduleVisible;
  }

  private selectChargeForm = {};

  private handleAddRange() {
    (this.formData.openRanges as any[]).push({
      reserve: [],
      use: [],
    });
  }

  private handleRemoveRange(index: number) {
    this.formData.openRanges.splice(index, 1);
  }

  private handleHoliday() {
    const defaultHolidayForm = {
      reason: '',
      dateRange: [],
      startDate: '',
      endDate: '',
    };
    this.formData.holidays.push(defaultHolidayForm);
  }

  private handleRemoveHoliday(index: any) {
    this.$confirm('정말 삭제하시겠습니까?', '휴일 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'warning',
    }).then(() => {
      this.formData.holidays.splice(index, 1);
    });
  }

  private handleAddOption() {
    (this.formData.options as any).push({
      name: '',
      price: 0,
    });
  }

  private handleRemoveOption(index: number) {
    this.formData.options.splice(index, 1);
  }

  private handleUsableAllMonths(value: boolean, index: number) {
    if (index === 0) {
      this.formData.months.forEach((month: any) => {
        month.usable = value;
      });
    }
  }

  private handlePriceAllMonths(index: number) {
    if (index === 0) {
      this.$confirm(`정말 모든월 요금을 ${this.formData.months[0].price}원으로 변경하시겠습니까?`, '게시판 삭제', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        type: 'info',
      }).then(() => {
        this.formData.months.forEach((month: any) => {
          month.price = this.formData.months[0].price;
        });
      });
    }
  }

  private handleDeleteSchedulePart() {
    this.scheduleType = null;
  }
}
